'use strict';
import { createAccountApi, accountErrorMessage } from '@dealr/api-account';
import * as core from '@dealr/core-account';
import * as presenter from '@dealr/presenter-account';
import { createAngularHttpTransport } from '@dealr/transport';
function browserWebAuthn() {
  var nav = typeof navigator !== 'undefined' ? navigator : null;
  var supported = core.webAuthnSupported({
    publicKeyCredential: typeof window !== 'undefined' ? window.PublicKeyCredential : null,
    credentials: nav && nav.credentials
  });
  if (!supported) return null;
  return {
    create: function (publicKey) {
      return nav.credentials.create({
        publicKey: publicKey
      });
    },
    get: function (publicKey) {
      return nav.credentials.get({
        publicKey: publicKey
      });
    }
  };
}
function confirmLogin(prompt) {
  var message = String(prompt.message || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  return window.confirm(message || 'Another session is already active. Continue and sign out the other session?');
}
angular.module('app').factory('dealrAccount', ['$http', function ($http) {
  return {
    api: createAccountApi(createAngularHttpTransport($http), {
      confirmLogin: confirmLogin
    }),
    core: core,
    presenter: presenter,
    errorMessage: accountErrorMessage,
    webauthn: browserWebAuthn
  };
}]);